// extracted by mini-css-extract-plugin
export default {"fieldWrapper":"EditableLabel_fieldWrapper__cHP3P","field":"EditableLabel_field__Ryf4n","disabled":"EditableLabel_disabled__9R92q"};